import { createAggregatedClient } from "@smithy/smithy-client";
import { CreateSignalingChannelCommand, } from "./commands/CreateSignalingChannelCommand";
import { CreateStreamCommand, } from "./commands/CreateStreamCommand";
import { DeleteEdgeConfigurationCommand, } from "./commands/DeleteEdgeConfigurationCommand";
import { DeleteSignalingChannelCommand, } from "./commands/DeleteSignalingChannelCommand";
import { DeleteStreamCommand, } from "./commands/DeleteStreamCommand";
import { DescribeEdgeConfigurationCommand, } from "./commands/DescribeEdgeConfigurationCommand";
import { DescribeImageGenerationConfigurationCommand, } from "./commands/DescribeImageGenerationConfigurationCommand";
import { DescribeMappedResourceConfigurationCommand, } from "./commands/DescribeMappedResourceConfigurationCommand";
import { DescribeMediaStorageConfigurationCommand, } from "./commands/DescribeMediaStorageConfigurationCommand";
import { DescribeNotificationConfigurationCommand, } from "./commands/DescribeNotificationConfigurationCommand";
import { DescribeSignalingChannelCommand, } from "./commands/DescribeSignalingChannelCommand";
import { DescribeStreamCommand, } from "./commands/DescribeStreamCommand";
import { GetDataEndpointCommand, } from "./commands/GetDataEndpointCommand";
import { GetSignalingChannelEndpointCommand, } from "./commands/GetSignalingChannelEndpointCommand";
import { ListEdgeAgentConfigurationsCommand, } from "./commands/ListEdgeAgentConfigurationsCommand";
import { ListSignalingChannelsCommand, } from "./commands/ListSignalingChannelsCommand";
import { ListStreamsCommand } from "./commands/ListStreamsCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTagsForStreamCommand, } from "./commands/ListTagsForStreamCommand";
import { StartEdgeConfigurationUpdateCommand, } from "./commands/StartEdgeConfigurationUpdateCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { TagStreamCommand } from "./commands/TagStreamCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UntagStreamCommand } from "./commands/UntagStreamCommand";
import { UpdateDataRetentionCommand, } from "./commands/UpdateDataRetentionCommand";
import { UpdateImageGenerationConfigurationCommand, } from "./commands/UpdateImageGenerationConfigurationCommand";
import { UpdateMediaStorageConfigurationCommand, } from "./commands/UpdateMediaStorageConfigurationCommand";
import { UpdateNotificationConfigurationCommand, } from "./commands/UpdateNotificationConfigurationCommand";
import { UpdateSignalingChannelCommand, } from "./commands/UpdateSignalingChannelCommand";
import { UpdateStreamCommand, } from "./commands/UpdateStreamCommand";
import { KinesisVideoClient } from "./KinesisVideoClient";
const commands = {
    CreateSignalingChannelCommand,
    CreateStreamCommand,
    DeleteEdgeConfigurationCommand,
    DeleteSignalingChannelCommand,
    DeleteStreamCommand,
    DescribeEdgeConfigurationCommand,
    DescribeImageGenerationConfigurationCommand,
    DescribeMappedResourceConfigurationCommand,
    DescribeMediaStorageConfigurationCommand,
    DescribeNotificationConfigurationCommand,
    DescribeSignalingChannelCommand,
    DescribeStreamCommand,
    GetDataEndpointCommand,
    GetSignalingChannelEndpointCommand,
    ListEdgeAgentConfigurationsCommand,
    ListSignalingChannelsCommand,
    ListStreamsCommand,
    ListTagsForResourceCommand,
    ListTagsForStreamCommand,
    StartEdgeConfigurationUpdateCommand,
    TagResourceCommand,
    TagStreamCommand,
    UntagResourceCommand,
    UntagStreamCommand,
    UpdateDataRetentionCommand,
    UpdateImageGenerationConfigurationCommand,
    UpdateMediaStorageConfigurationCommand,
    UpdateNotificationConfigurationCommand,
    UpdateSignalingChannelCommand,
    UpdateStreamCommand,
};
export class KinesisVideo extends KinesisVideoClient {
}
createAggregatedClient(commands, KinesisVideo);
